"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Th_1 = require("./Th");
exports.default = Th_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Th/index.js
// module id = 550
// module chunks = 8